module.exports = __webpack_public_path__ + "static/media/Livre3.63d78e5f.png";